import { render, staticRenderFns } from "./target-wallet-form.vue?vue&type=template&id=045eb778&"
import script from "./target-wallet-form.vue?vue&type=script&lang=js&"
export * from "./target-wallet-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports